export default function getDefaultFromDate(): Date {
  return VisitWidget.global.getBeginningOfDayMoment().toDate();
}
